interface PageParams {
    sites: string[];
}

export const pageParams: PageParams = {
    sites: ['us'],
};

export const sites = pageParams.sites;
